import { useMemo } from "react";
import { match } from "path-to-regexp";
import { useLocation } from "react-router-dom";
import { useGlobal } from "reactn";
import { Ramp, TaglessAdUnits } from "@outplayed/ramp";

export const RampContainer = () => {
  const location = useLocation();
  const [windowBreakpoint] = useGlobal("responsive");

  const adUnits = useMemo(() => {
    for (let path in adUnitsByPage) {
      if (match(path)(location.pathname)) {
        return adUnitsByPage[path][windowBreakpoint] || adUnitsByPage[path].default;
      }
    }
    return [];
  }, [location.pathname, windowBreakpoint]);

  return (
    <Ramp PUB_ID={process.env.PW_PUB_ID} WEBSITE_ID={process.env.PW_WEBSITE_ID} pathname={location.pathname} pwUnits={adUnits} />
  );
};

const defaultAdUnits = [{ type: TaglessAdUnits.BottomRail }, { type: TaglessAdUnits.CornerAdVideo }];

const adUnitsByPage = {
  ["/wow"]: {
    default: defaultAdUnits,
  },
  ...getAdUnitsPages(["/wow/classes-and-specs", "/wow/faq"], {
    default: defaultAdUnits,
  }),
  ...getAdUnitsPages(
    [
      "/wow/tier-list/dps-rankings",
      "/wow/tier-list/dps-rankings/raid",
      "/wow/tier-list/dps-rankings/pvp",
      "/wow/tier-list/tank-rankings",
      "/wow/tier-list/tank-rankings/raid",
      "/wow/tier-list/tank-rankings/pvp",
      "/wow/tier-list/healer-rankings",
      "/wow/tier-list/healer-rankings/raid",
      "/wow/tier-list/healer-rankings/pvp",
      "/wow/:spec/:class/talents",
      "/wow/:spec/:class/talents/raid",
      "/wow/:spec/:class/gear",
      "/wow/:spec/:class/gear/raid",
      "/wow/:spec/:class/gems-and-enchants",
      "/wow/:spec/:class/gems-and-enchants/raid",
      "/wow/:spec/:class/builds",
      "/wow/:spec/:class/builds/raid",
      "/wow/:spec/:class/trinkets",
      "/wow/:spec/:class/trinkets/raid",
      "/wow/:spec/:class/pvp",
    ],
    {
      default: defaultAdUnits,
      // DESKTOP_MEDIUM: [
      //   { type: TaglessAdUnits.LeftRail },
      //   { type: TaglessAdUnits.RightRail },
      //   { type: TaglessAdUnits.BottomRail },
      //   { type: TaglessAdUnits.CornerAdVideo },
      // ],
      // DESKTOP_LARGE: [
      //   { type: TaglessAdUnits.LeftRail },
      //   { type: TaglessAdUnits.RightRail },
      //   { type: TaglessAdUnits.BottomRail },
      //   { type: TaglessAdUnits.CornerAdVideo },
      // ],
    },
  ),
};

function getAdUnitsPages(routes, adUnits) {
  const map = {};
  for (let route of routes) {
    map[route] = adUnits;
  }
  return map;
}
